import type { ReactNode } from 'react';
import { Button, Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogVisuallyHidden } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
export interface AlertDialogProps {
  title: string;
  body?: ReactNode;
  confirmText?: string;
}
interface AlertDialogInternalProps extends AlertDialogProps {
  isOpen: boolean;
  onClose: (result?: boolean) => void;
}
const AlertDialogContent = ({
  title,
  body,
  confirmText,
  isOpen,
  onClose
}: AlertDialogInternalProps) => {
  const {
    t
  } = useTranslation(['common']);
  const buttonText = confirmText ?? t('common.alertDialog.confirmText');
  return <Dialog open={isOpen} onOpenChange={open => !open && onClose(false)} data-sentry-element="Dialog" data-sentry-component="AlertDialogContent" data-sentry-source-file="AlertDialog.tsx">
      <DialogContent hasDim onDimClick={() => onClose(false)} className="flex w-[295px] max-w-[calc(100vw-32px)] flex-col overflow-hidden mobile-lg:w-[320px]" data-sentry-element="DialogContent" data-sentry-source-file="AlertDialog.tsx">
        <DialogHeader className="px-md pb-xs pt-md mobile-lg:px-lg mobile-lg:pb-xs mobile-lg:pt-lg" data-sentry-element="DialogHeader" data-sentry-source-file="AlertDialog.tsx">
          <DialogTitle className="text-heading-md-bold" data-sentry-element="DialogTitle" data-sentry-source-file="AlertDialog.tsx">{title}</DialogTitle>
        </DialogHeader>
        <DialogVisuallyHidden data-sentry-element="DialogVisuallyHidden" data-sentry-source-file="AlertDialog.tsx">
          <DialogDescription data-sentry-element="DialogDescription" data-sentry-source-file="AlertDialog.tsx">{title}</DialogDescription>
        </DialogVisuallyHidden>
        {body && <DialogBody className="px-lg text-body-md-regular text-default max-mobile-lg:px-md">
            {body}
          </DialogBody>}
        <DialogFooter className="p-md mobile-lg:p-lg" data-sentry-element="DialogFooter" data-sentry-source-file="AlertDialog.tsx">
          <Button className="w-full" variant="contained" intent="strong" size="md" onClick={() => onClose(true)} data-sentry-element="Button" data-sentry-source-file="AlertDialog.tsx">
            {buttonText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>;
};
export const alertDialog = {
  open(props: AlertDialogProps) {
    return overlay.open(({
      isOpen,
      close
    }) => <AlertDialogContent {...props} isOpen={isOpen} onClose={close} />);
  },
  async openAsync(props: AlertDialogProps) {
    const result = await overlay.openAsync<boolean>(({
      isOpen,
      close
    }) => <AlertDialogContent {...props} isOpen={isOpen} onClose={v => close(v ?? false)} />);
    return !!result;
  }
};